/**
 * Hidden shot list for Tammy. Preview only.
 * Not linked from the live header. Not in the sitemap.
 */

import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { applySeo } from '../../utils/seo';
import {
  PREVIEW_MUST_HAVE_SHOTS,
  PREVIEW_OPTIONAL_SHOTS,
  PREVIEW_PHOTOS_PATH,
  PREVIEW_PHOTOS_SEO,
} from './previewPhotoShots';
import './previewHome.css';

export default function PreviewPhotosPage() {
  useEffect(() => {
    applySeo({
      title: PREVIEW_PHOTOS_SEO.title,
      description: PREVIEW_PHOTOS_SEO.description,
      canonicalPath: PREVIEW_PHOTOS_PATH,
      keywords: PREVIEW_PHOTOS_SEO.keywords,
      robots: PREVIEW_PHOTOS_SEO.robots,
    });
  }, []);

  return (
    <div className="preview-paper section-padding">
      <div className="container-custom max-w-2xl">
        <p className="text-sm font-semibold uppercase tracking-[0.2em] text-primary-700">
          Preview only
        </p>
        <h1 className="mt-2 font-display text-3xl font-bold text-gray-900 md:text-4xl">
          Photos to send Humberto
        </h1>
        <p className="mt-4 text-gray-600">
          These photos are for the live homepage. Your phone is perfect. Eight to twelve
          photos is plenty.
        </p>

        <h2 className="mt-10 font-display text-2xl font-bold text-gray-900">Please take these</h2>
        <ol className="mt-4 list-decimal space-y-4 pl-5 text-gray-800">
          {PREVIEW_MUST_HAVE_SHOTS.map((shot) => (
            <li key={shot.title}>
              <span className="font-semibold">{shot.title}.</span> {shot.detail}
            </li>
          ))}
        </ol>

        <h2 className="mt-10 font-display text-2xl font-bold text-gray-900">Nice if easy</h2>
        <ul className="mt-4 list-disc space-y-4 pl-5 text-gray-800">
          {PREVIEW_OPTIONAL_SHOTS.map((shot) => (
            <li key={shot.title}>
              <span className="font-semibold">{shot.title}.</span> {shot.detail}
            </li>
          ))}
        </ul>

        <h2 className="mt-10 font-display text-2xl font-bold text-gray-900">How to shoot</h2>
        <ul className="mt-4 list-disc space-y-2 pl-5 text-gray-700">
          <li>Use the back camera. Lights on. Daytime is best.</li>
          <li>Walk closer instead of zooming.</li>
          <li>Hold the phone sideways for shop and food photos.</li>
          <li>Send the original from the camera roll, not a screenshot.</li>
          <li>Do not use the door lettering that says nut friendly. The shop is not nut friendly.</li>
        </ul>

        <p className="mt-10 text-gray-700">
          Text the originals back to Humberto when you can.
        </p>
        <p className="mt-6">
          <Link to="/" className="font-semibold text-primary-700 underline underline-offset-2">
            Back to the homepage
          </Link>
        </p>
      </div>
    </div>
  );
}
